import { Box, DialogProps } from '@material-ui/core';
import React from 'react';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { DialogActionButton } from '@/components/shared/components/StandardActionDialog/types/DialogActionButton';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface StandardActionDialogProps {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  setActionDialogParams;
  titleTextElement?: JSX.Element;
  actionDescriptionTextElement?: JSX.Element;
  actionButtonsArray?: DialogActionButton[];
  children?: React.ReactNode;
  dialogProps?: Partial<DialogProps>;
  loading?: boolean;
  altCancelButtonTextId?: string;
}

export const StandardActionDialog = ({
  opened,
  setOpened,
  setActionDialogParams,
  titleTextElement = <Text tId={'TITLE'} />,
  actionDescriptionTextElement,
  actionButtonsArray,
  children,
  dialogProps,
  loading,
  altCancelButtonTextId,
}: StandardActionDialogProps) => {
  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton
            disabled={loading}
            onClick={() => {
              if (setActionDialogParams) {
                setActionDialogParams(undefined);
              }
              setOpened(false);
            }}
          >
            <Text tId={altCancelButtonTextId ? altCancelButtonTextId : 'CANCEL'} />
          </StandardButton>
          {actionButtonsArray && actionButtonsArray?.length > 0
            ? actionButtonsArray.map((actionButton, key) => (
                <StandardButton
                  key={key}
                  disabled={actionButton?.disabled}
                  variant={'contained'}
                  loading={loading}
                  onClick={actionButton.onClick}
                >
                  <Text tId={actionButton.buttonLabelTextId} />
                </StandardButton>
              ))
            : undefined}
        </>
      }
      dialogProps={dialogProps}
    >
      <Box mb={4}>
        <Font variant="h3" color="title">
          {titleTextElement}
        </Font>
      </Box>
      {actionDescriptionTextElement && (
        <Box>
          <Font variant="body2" color="textSecondary">
            {actionDescriptionTextElement}
          </Font>
        </Box>
      )}
      <Box>{children}</Box>
    </NemuruDialog>
  );
};
